import "./modules/global";
import { AnchorScroll } from "./modules/utils";
import Search from "./modules/search";

window.addEventListener("load", () => {
	new AnchorScroll("#topmenu a", 100);
});
